var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.643.133c.083-.083.218-.083.3 0 .084.083.084.217.001.3L3.69 3.692c-.083.083-.218.083-.3 0L.132.434C.05.35.05.216.133.133c.083-.083.218-.083.3 0L3.54 3.241 6.643.133z"}));
}

Chevron.defaultProps = {"width":"7","height":"4","viewBox":"0 0 7 4"};

module.exports = Chevron;

Chevron.default = Chevron;
